import actionWrapper from '../../lib/actionWrapper';
import axios from '../../lib/api';
import {ByteArrayResource} from '../type/dtos/ByteArrayResource';

export default {
    namespace: 'objectStore',

    state: {
        downloadedObjects: {},
    },

    effects: (dispatch: any) => ({
        downloadObject(key: string) {
            return actionWrapper(
                 () => axios.get(`objectStore/download?fileName=${key}`)
                     .then((res) => {
                         dispatch.objectStore.fetchDownloadObject_reducer({[key]: res?.data});
                         return res;
                     }),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        /*
        uploadObject(data: FormData) {
            return actionWrapper(
                 () => axios.post('objectStore/upload', data),
                dispatch.util.errorHandler,
                // dispatch.util.sendAlert,
            );
        },
        */
    }),

    reducers: {
        fetchDownloadObject_reducer(state: any, payload: {key: string, object: ByteArrayResource}) {
            return {...state, downloadedObjects: {...(state?.downloadedObjects || {}), ...payload}};
        },
    },
};
